<template>
  <van-popup
    v-model:show="innerShow"
    position="right"
    :style="{ width: '100%', height: '100%' }"
  >
    <div class="i-part__content">
      <van-nav-bar
        :title="readonly ? '查看配件' : '选择配件'"
        left-text="返回"
        left-arrow
        @click-left="
          readonly = false;
          innerShow = false;
        "
      />
      <template v-if="!readonly">
        <form action="/">
          <van-search
            v-model="formData.keyword"
            @search="onSearch"
            placeholder="请输入搜索关键词"
          />
        </form>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="formData.storage_id"
            :options="state.storageOption"
            @change="dropdownChange"
          />
          <van-dropdown-item
            v-model="formData.type_ids"
            :options="state.partTypeOption"
            @change="dropdownChange"
          />
        </van-dropdown-menu>
        <div class="i-part__body">
          <van-card
            v-for="item in state.partList"
            :key="item.id"
            :price="item.price"
            :desc="item.part_fall_name"
            :title="item.part_name"
          >
            <template #tags>
              <van-tag plain type="danger" style="margin-right: 10px"
                >剩余{{ item.stock }}{{ item.unit_name }}</van-tag
              >
              <van-tag plain type="danger">{{ item.part_model }}</van-tag>
            </template>
            <template #num>
              <!--      :before-change="beforeChange(item)" -->
              <van-stepper
                :min="0"
                :max="
                  partPriceMap[item.id].number > item.stock ? 9999 : item.stock
                "
                v-model="partPriceMap[item.id].number"
                theme="round"
                button-size="22"
                input-width="50px"
              />
            </template>
          </van-card>
        </div>
        <div style="height: 50px; padding: var(--van-submit-bar-padding)"></div>
        <van-submit-bar
          :price="totalPrice * 100"
          button-text="保存配件"
          @submit="onSubmit"
          button-color="#1989fa"
        />
      </template>
      <template v-else>
        <div class="i-part__body">
          <template v-for="item in partPriceMap" :key="item.id">
            <van-card
              v-if="item.number"
              :desc="`规格型号：${item.part_model}`"
              :price="item.price"
              :title="item.part_name"
              :num="item.number"
            >
            </van-card>
          </template>
        </div>
      </template>
    </div>
  </van-popup>
</template>
<script>
import { useVModel } from "@vueuse/core";
import { computed, reactive, ref } from "vue";
import { baseService, partService } from "@/service";
import _ from "lodash";
import { Toast } from "vant";

export default {
  nam: "part",
  props: {
    default: {
      type: Object,
    },
    show: {
      type: Boolean,
      requried: true,
    },
  },
  setup(props, { emit }) {
    const readonly = ref(false);

    const openDetail = () => {
      readonly.value = true;
      emit("update:show", true);
    };

    const state = reactive({
      storageOption: [{ text: "全部", value: "" }],
      partTypeOption: [{ text: "全部", value: "" }],
      partList: [],
    });
    const formData = reactive({
      keyword: "",
      storage_id: "",
      type_ids: "",
    });
    // 库房
    const getStorageList = async () => {
      const { data } = await baseService.storageList();
      state.storageOption.push(
        ...data.map((item) => ({
          text: item.storage_name,
          value: item.id,
        }))
      );
    };
    getStorageList();
    // 分类
    const getPartTypeList = async () => {
      const { data } = await partService.partTypeList();
      state.partTypeOption.push(
        ...data.map((item) => ({
          text: item.part_type_name,
          value: item.id,
        }))
      );
    };
    getPartTypeList();
    const partPriceMap = reactive(_.cloneDeep(props.default));
    const getPartList = async () => {
      try {
        const { data } = await partService.partList(formData);
        data.forEach((item) => {
          if (!partPriceMap[item.id]) {
            partPriceMap[item.id] = {
              number: 0,
              ...item,
            };
          }
        });
        state.partList = data;
      } catch (error) {
        state.partList = [];
      }
    };
    getPartList();
    const dropdownChange = () => {
      getPartList();
    };

    const onSearch = () => {
      getPartList();
    };

    const totalPrice = computed(() => {
      return Object.values(partPriceMap).reduce((parent, child) => {
        return parent + child.number * child.price;
      }, 0);
    });

    const onSubmit = () => {
      emit("submit", partPriceMap);
    };

    const beforeChange = (item) => {
      return (value) => {
        if (value > item.stock) {
          Toast.fail(`${item.part_name}数量不能超过库存${item.stock}`);
          return false;
        }
        return true;
      };
    };
    return {
      onSearch,
      state,
      formData,
      dropdownChange,
      totalPrice,
      onSubmit,
      partPriceMap,
      readonly,
      openDetail,
      beforeChange,
      innerShow: useVModel(props, "show", emit),
    };
  },
};
</script>
<style lang="less" scoped>
.i-part__content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.i-part__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
